@use "@fukuri-admins/ui/layout" as *;

.MenuItem {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  transition: all 0.2s ease-out;
  text-decoration: none;
  border-bottom: 1px solid $NATURAL_200;
  cursor: pointer;
  font-weight: 600;
  font-size: 15px;
  color: $NATURAL_600;

  &.active {
    color: $Text;
    background-color: $NATURAL_100;
    cursor: default;
  }

  img {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    object-fit: cover;
  }

  &:hover {
    background-color: $NATURAL_100;
    ul {
      display: flex;
      flex-direction: column;
    }
  }
}
